import { Component } from '@angular/core';

@Component({
    selector: 'app-politica-devolucion-rembolzo',
    templateUrl: './politica-devolucion-rembolzo.component.html',
    styleUrls: ['./politica-devolucion-rembolzo.component.scss'],
    standalone: false
})
export class PoliticaDevolucionRembolzoComponent {}
